import React, { FunctionComponent } from 'react';
// import styles from "./Play.module.scss";
import audioOnButton from "../../../images/audioOn.svg";
import audioOffButton from "../../../images/audioOff.svg";
import { isEs } from "../../../libs/lang";


/**
 * Primary UI component for user interaction
 */
const Audio = ({ariaPressed, toggle = false, alt, onClick, tabIndex}) => {

	const ariaAltOn = () => isEs() ? "Audio activado" : "Audio On Button";
	const ariaAltOff = () => isEs() ? "Audio desactivado" : "Audio Off Button"

	const toggleImage = toggle ? <img src={audioOnButton} alt/> : <img src={audioOffButton} alt/>;

	return (
		<div
			aria-pressed={ariaPressed}
        role="button"
			className={'audioToggle'}
			tabIndex={tabIndex}
			aria-label={`${ariaPressed ? ariaAltOn() : ariaAltOff()}`}
			onClick={(e) => onClick(e)}
			style={{}}
			onKeyDown={(e) => onClick(e)}
		>
			{toggleImage}
		</div>
	);
};

export default Audio;
